import React from "react";
import TableTrPopup from "./TableTrPopup";

const TableTr = ({popup, productKey, isSpecial, tr, children}) => {
    if (popup) {
        return (
            <TableTrPopup
                key={`product_key_TableTr_tr_${productKey}`}
                productKey={productKey}
                isSpecial={isSpecial}
                isSpecialProduct={tr.id_special_product}
                productType={tr.product_type}
            >
                {children}
            </TableTrPopup>
        );
    }
    return (
        <tr
            key={`product_key_TableTr_tr_${productKey}`}>
            {children}
        </tr>
    );
}

export default TableTr;